/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// ---------------------------------------------------------------------------
// Pílula de status compartilhada do módulo Financeiro (espelha o padrão dos
// *StatusBadge de Comercial e Recrutamento). Cai num neutro para valor
// desconhecido — nunca quebra. As pílulas específicas (BankAccountStatus,
// CredentialStatus, Environment) mapeiam enum → variante + label e delegam a
// render aqui.
// ---------------------------------------------------------------------------

const VARIANTS = {
   neutral: { bg: 'rgba(0,0,0,0.06)', border: 'rgba(0,0,0,0.15)', text: '#444' },
   blue: { bg: 'rgba(24,95,165,0.12)', border: 'rgba(24,95,165,0.35)', text: '#0C447C' },
   green: { bg: 'rgba(46,125,50,0.12)', border: 'rgba(46,125,50,0.35)', text: '#1b5e20' },
   amber: { bg: 'rgba(133,79,11,0.12)', border: 'rgba(133,79,11,0.35)', text: '#854F0B' },
   red: { bg: 'rgba(171,32,32,0.12)', border: 'rgba(171,32,32,0.35)', text: '#8a1f1f' },
};

const Pill = styled.span`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: 4px 12px;
   border-radius: 999px;
   font-size: 11.5px;
   font-weight: 800;
   letter-spacing: 0.01em;
   border: 1px solid ${({ $border }) => $border};
   background: ${({ $bg }) => $bg};
   color: ${({ $text }) => $text};
   white-space: nowrap;
`;

export default function StatusBadge({ variant = 'neutral', children }) {
   const cfg = VARIANTS[variant] ?? VARIANTS.neutral;
   return (
      <Pill $bg={cfg.bg} $border={cfg.border} $text={cfg.text}>
         {children}
      </Pill>
   );
}

StatusBadge.propTypes = {
   variant: PropTypes.oneOf(['neutral', 'blue', 'green', 'amber', 'red']),
   children: PropTypes.node,
};
